// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";
// // import statusHouseCertification from "../../assets/table_8-6-24.png";


// export default function DFIAlicence() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                         <div>

//                   <h1>Duty Free Import Authorisation (DFIA licence)</h1>
//             <p>A Duty-Free Import Authorization (DFIA) is a document that allows duty-free import of inputs required in the production of an export product, with normal allowances for wastage, energy, fuel, catalyst, and other factors. Many are employed in the process of obtaining the export product.</p>
//             <p>The Director-General of Foreign Trade (DGFT) has the authority to exclude any product(s) from the plan via public notice and public interest. Provisions of paragraphs 4.12, 4.18, 4.20, 4.21 and 4.24 of FTP is applicable to DFIA.</p>
//             <p>The authorization will be based on the input and export item norms outlined in the Standard Input and Output Norms (SION). As a result, the import entitlement must be restricted to the amount specified in SION.</p>
//             <p>Previously, duty-free import of mandatory spares up to 10% of the CIF value of the Authorization that must be exported/supplied as the end product may have been permitted under the plan. This type of authorization might be given to a merchant exporter or a manufacturer exporter who is connected to a supporting manufacturer</p>
                       
//                     </div>
//                  </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>The new Duty Free Import Authorisation (DFIA) Scheme is prescribed in Chapter 4 of FTP explains the details of Duty-Free Import Authorization and how it differs from the old Foreign Trade Policy (FTP) 2009-2014. Provisions of paragraphs4.26, 4.27, 4.28, 4.48, 4.49(e) & 4.49 (f) and 4.52 of this Handbook of Procedures shall also be applicable for DFIA Scheme. The following is a description of the new Duty-Free Import Authorization Scheme policy:</p>
                                  
//                                   <h2>Eligibility to apply for a Duty-Free Import Authorization</h2>
//                                   <p>(i) For products for which Standard Input Output Norms have been notified, a Duty-Free Import Authorization will be provided after export.</p>
//                                   <p>(ii) Any Merchant Exporter must provide the name and address of the supporting manufacturer of the export product on the export document, such as the Shipping Bill / Bill of Export / Tax invoice for export prescribed under the GST rules.</p>
//                                   <p>(iii) Before exporting under a Duty-Free Import Authorization, an application must be lodged with the relevant Regional Authority. </p>
                              
//                                   <h2>Addition of Minimal Value</h2>
//                                   <p>To be successful, minimum value addition of 20% must be met. If greater value addition is required for Advance Authorisation in Appendix 4C, the same value addition is required for Duty-Free Import Authorisation as well.</p>

//                                   <h2>Validity and Transferability of DFIA under the 2015-20 EXIM Policy (FTP 2015-20)</h2>
//                                   <ul>
//                                         <li> Before beginning to export under the DFIA, the applicant must submit an online application to the relevant Regional Authority.</li>
//                                         <li>The export must be completed within 12 months of the date of the application's online filing and generation of the file number.</li>
//                                         <li>When exporting or supplying, the applicant must include the file number on all export documents, such as the Shipping Bill / Bill of Export / Tax invoice for supply prescribed under the GST rules.</li>
//                                         <li>After exports are completed and proceeds are realised, a request for the issue of a transferable Duty-Free Import Authorization may be made to the competent Regional authority.</li>
//                                         <li>Authorization must be obtained from the competent Regional Authority within twelve months of the date of export or six months (or further time permitted by RBI for realisation) from the date of realisation of export proceeds, whichever is later.</li>
//                                         <li>According to paragraph 9.03 of the Hand Book of Procedures, an applicant may file an application up to 24 months after the date of generation of the file number.</li>
//                                         <li>Each SION will require its own DFIA.</li>
//                                         <li>DFIA exports shall be made from any port listed in 4.37 of Hand Book of procedure.</li>
//                                         <li>Where SION mandates an ‘Actual User' criterion for any input, no Duty-Free Import Authorisation for an export product will be provided.</li>
//                                         <li>The Regional Authority will issue transferrable DFIAs with a 12-month validity period from the date of issuance. The Regional Authority will not issue any more revalidations.
//                                       </li>
//                                   </ul>

//                                   <h2>Procedure for the DFIA Scheme - Steps to Follow for the Duty-Free Import Authorization Scheme</h2>
//                                   <p>The processes to follow under the duty-free import permission scheme are as follows:</p>
//                                   <p>Step 1: The applicant must determine whether or not the exported item is eligible for DFIA in SION.</p>
//                                   <p>Step 2: If the export item meets SION requirements, the applicant must submit an online application through the DGFT site and obtain a File number.</p>
//                                   <p>Step 3: Export must be completed within 12 months of the file number being issued.</p>
//                                   <p>Step 4: On all export documents, such as shipping bills, tax invoices, and bills of export, the applicant must include the generated file number.</p>
//                                   <p>Step 5: Once the export obligation has been fulfilled, the applicant must apply for a transferable DFIA licence.</p>
//                                   <p>Step 6: The applicant must submit necessary papers to the pertinent DGFT RA, such as a shipping bill, an E-BRC, a tax invoice, and so on.</p>
//                                   <p>Step 7: The DGFT RA will review the provided documentation and, if they are clear, will issue the transferable DFIA licence within 20-25 days.</p>
//                                   <p>Step 8: Once the DFIA licence has been given by the DGFT RA, the DFIA licence must be registered in customs for verification purposes.</p>
//                                   <p>Step 9: The applicant can either import or sell the DFIA licence on the market.</p>
                              
//                                   <h2>How can we help you with the DFIA scheme?</h2>
//                                   <p>We are a group of DGFT experts who can assess the DFIA scheme's viability for exports.</p>
//                                   <p>We offer a variety of services to assist exporters and manufacturers in growing their businesses by providing various incentives and streamlining the often-complicated export procedure. Begin working with us right now to take your company to the next level.</p>
                              
//                                   <h2>At Apex  What We Do</h2>
//                                   <p>In the Foreign Trade Policy, Duty exemption schemes were introduced to give way to the dutyfree import of raw materials or inputs required for the manufacturing of export products, which made life easier for the exporters. Our dedicated team of Directorate General of Foreign Trade experts analyze the feasibility of the DFIA scheme for exports. Assisting in the documentation, preparing the application and making the online application followed by submitting the hardcopy in DGFT, we do it all. We tend to coordinate with DGFT and other departments for the transferable DFIA licence and redemption of the same.</p>
                                  
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function DFIA() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Duty-Free Import Authorization (DFIA)
              </h1>

              <p>
                DFIA is an export incentive scheme under India’s Foreign Trade Policy
                that allows duty-free import of inputs required for manufacturing
                export products.
              </p>

              <p>
                It helps exporters reduce costs, improve margins, and enhance
                global competitiveness.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of DFIA Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Duty-free import of inputs</li>
            <li><FaCheckCircle /> Reduce manufacturing costs</li>
            <li><FaCheckCircle /> Improve export competitiveness</li>
            <li><FaCheckCircle /> Promote value addition</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Exporters who completed export obligations</li>
            <li><FaCheckCircle /> Manufacturer exporters</li>
            <li><FaCheckCircle /> Merchant exporters with supporting manufacturers</li>
            <li><FaCheckCircle /> Valid IEC holders</li>
          </ul>

          {/* SCOPE */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Scope of DFIA
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Import raw materials, fuel, oil, catalysts duty-free</li>
            <li><FaCheckCircle /> Use inputs only for export production</li>
            <li><FaCheckCircle /> Transfer DFIA license (as per policy)</li>
            <li><FaCheckCircle /> Post-export duty exemption</li>
          </ul>

          {/* EXPORT OBLIGATION */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Export Obligation
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Fulfill export obligation within time</li>
            <li><FaCheckCircle /> Maintain proper records</li>
            <li><FaCheckCircle /> Ensure correct usage of inputs</li>
            <li><FaCheckCircle /> Follow DGFT & customs rules</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Provide IEC and business details</li>
            <li><FaCheckCircle /> Submit product specifications</li>
            <li><FaCheckCircle /> Declare input requirements</li>
            <li><FaCheckCircle /> Submit export documents</li>
            <li><FaCheckCircle /> DGFT approval and license issuance</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Benefits of DFIA
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Customs duty exemption</li>
            <li><FaCheckCircle /> Reduced production costs</li>
            <li><FaCheckCircle /> Improved profit margins</li>
            <li><FaCheckCircle /> Better global competitiveness</li>
            <li><FaCheckCircle /> Transferable benefits</li>
          </ul>

          {/* CONDITIONS */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Key Conditions
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Must follow SION norms</li>
            <li><FaCheckCircle /> Minimum value addition required</li>
            <li><FaCheckCircle /> Authorization issued post-export</li>
            <li><FaCheckCircle /> Non-compliance leads to penalties</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide end-to-end DFIA support including
            eligibility assessment, documentation, application filing, DGFT
            coordination, and post-license compliance.
          </p>

        </Container>
      </section>
    </div>
  );
}